import * as Yup from 'yup'

const promoCodeValidator = Yup.object ({
  code: Yup
    .string ()
    .required ('Insira um código')
    .max (32, 'O código deve ter até 32 caracteres'),

  description: Yup
    .string ()
    .required ('Insira uma descrição')
    .max (256, 'A descrição deve ter até 256 caracteres'),

  shortDescription: Yup
    .string ()
    .required ('Insira uma descrição resumida')
    .max (128, 'A descrição resumida deve ter até 128 caracteres'),

  expiresAt: Yup
    .string ()
    .required ('Selecione uma data de validade'),
  
  discount_type: Yup
    .object ()
    .nullable ()
    .required ('Selecione um tipo de desconto'),
})

export default promoCodeValidator
